import { render } from "./PageNotFoundComponent.vue?vue&type=template&id=1c99498c"
import script from "./PageNotFoundComponent.vue?vue&type=script&lang=js"
export * from "./PageNotFoundComponent.vue?vue&type=script&lang=js"

import "./PageNotFoundComponent.vue?vue&type=style&index=0&id=1c99498c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__